module.exports = __webpack_public_path__ + "img/1462535746.526242af.jpg";